import { v4 } from 'uuid';

const newGuid = (): string => v4();
const emptyGuid = (): string => '00000000-0000-0000-0000-000000000000';

export { newGuid, emptyGuid };
